import MetricsConst from '@/views/Metrics/common/MetricsConst';

export function getMaxMonth(deploymentOnProd) {
  let mx = 0;
  for (let key of Object.keys(deploymentOnProd.deploymentProdData)) {
    let numberOfMonth = 0;
    for (let division of MetricsConst.DIVISIONS) {
      if (!(division in deploymentOnProd.deploymentProdData[key])) {
        deploymentOnProd.deploymentProdData[key][division] = 0;
      }
      numberOfMonth += deploymentOnProd.deploymentProdData[key][division];
    }
    mx = Math.max(mx, numberOfMonth);
    deploymentOnProd.deploymentProdData[key][
      MetricsConst._TOTAL_MONTHS
    ] = numberOfMonth;
  }
  return mx;
}
export function showFiniteNumberOfDigit(num, numberOfDigit) {
  if (typeof num !== 'number') {
    return undefined;
  }
  if (typeof numberOfDigit !== 'number') {
    numberOfDigit = 0;
  }
  let numLst = num.toString().split('.'),
    result =
      numLst.length === 1
        ? num
        : numLst[0] + '.' + numLst[1].slice(0, numberOfDigit);
  return +result;
}
function compareDate(year1, month1, year2, month2) {
  if (year1 > year2) {
    return 1;
  }
  if (year1 < year2) {
    return -1;
  }
  if (month1 > month2) {
    return 1;
  }
  if (month1 < month2) {
    return -1;
  }
  return 0;
}

export function sliceChartData(releasesOnProdData, dateRange) {
  let startDate = dateRange[0].getFullYear() + '-' + dateRange[0].getMonth(),
    endDate = dateRange[1].getFullYear() + '-' + dateRange[1].getMonth();
  let startYear = +startDate.split('-')[0],
    endYear = +endDate.split('-')[0],
    startMonth = +startDate.split('-')[1],
    endMonth = +endDate.split('-')[1];
  let releaseOnProdDataCopy = [];
  releasesOnProdData.map(release => {
    let releaseDate = new Date(release.releaseName);
    if (
      compareDate(
        releaseDate.getFullYear(),
        releaseDate.getMonth(),
        startYear,
        startMonth
      ) >= 0 &&
      compareDate(
        releaseDate.getFullYear(),
        releaseDate.getMonth(),
        endYear,
        endMonth
      ) <= 0
    ) {
      releaseOnProdDataCopy.push(release);
    }
  });
  return releaseOnProdDataCopy;
}
function addLeadingZero(value) {
  return value < 10 ? '0' + value : value;
}
export function getTheSizeOfScreen(window, document) {
  let win = window,
    doc = document,
    docElem = doc.documentElement,
    body = doc.getElementsByTagName('body')[0],
    width = win.innerWidth || docElem.clientWidth || body.clientWidth,
    height = win.innerHeight || docElem.clientHeight || body.clientHeight;
  return [width, height];
}

function reformatDate(releaseDate) {
  releaseDate = releaseDate.replaceAll(' ', 'T');
  let newDate = new Date(releaseDate);
  let day = newDate.getDate(),
    month = newDate.getMonth() + 1,
    year = newDate.getFullYear(),
    hour = +releaseDate.split('T')[1].slice(0, 2),
    minute = +releaseDate.split('T')[1].slice(3, 5);
  return (
    addLeadingZero(day) +
    '/' +
    addLeadingZero(month) +
    '/' +
    year +
    ' ' +
    addLeadingZero(hour) +
    ':' +
    addLeadingZero(minute)
  );
}

export function exportToFileCsv(data, currentDivisionSelected) {
  let csv = [],
    row = [];
  if (data == null) {
    return;
  }
  row.push('ReleaseA');
  row.push('ReleaseB');
  row.push('TicketName');
  row.push('MergeDate');
  row.push('DeploymentDate');
  csv.push(row.join(';'));
  for (let releaseDate of Object.keys(data)) {
    for (let ticketName in data[releaseDate]) {
      let value = data[releaseDate][ticketName];
      if (!ticketName.startsWith('IT08PEARL')) {
        continue;
      }
      row = [];
      row.push(value['releaseA']);
      row.push(value['releaseB']);
      row.push(ticketName);
      row.push(reformatDate(value['mergeDate']));
      row.push(reformatDate(value['deploymentDate']));
      csv.push(row.join(';'));
    }
  }
  let dateOfFileDownload = new Date(),
    day = dateOfFileDownload.getDate(),
    month = dateOfFileDownload.getMonth() + 1,
    year = dateOfFileDownload.getFullYear(),
    hour = dateOfFileDownload.getHours(),
    minute = dateOfFileDownload.getMinutes(),
    second = dateOfFileDownload.getSeconds();
  downloadCSV(
    csv.join('\n'),
    `${currentDivisionSelected}_LeadTimeData${addLeadingZero(
      day
    )}_${addLeadingZero(month)}_${year}_${addLeadingZero(
      hour
    )}_${addLeadingZero(minute)}_${addLeadingZero(second)}.csv`
  );
}
function downloadCSV(csv, filename) {
  let csvFile;
  let downloadLink;

  //define the file type to text/csv
  csvFile = new Blob([csv], { type: 'text/csv' });
  downloadLink = document.createElement('a');
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = 'none';

  document.body.appendChild(downloadLink);
  downloadLink.click();
}
